const SCHEDULING_DAYS = 'DIAS_AGENDAMENTO';
const TRANSCRIPTION_APPROVE_PARAM = 'APROVACAO_FARMACEUTICA';
const PATIENT_CLASSIFICATION_PARAM = 'CLASSIFICACAO_PACIENTE';
const TRANSCRIPTION_MIN_CHECKS = 'MINIMO_COINCIDENTE';
const CANCELLATION_REASON = 'MOTIVO_CANCELAMENTO';
const EXPIRATION_TIME = 'TEMPO_INATIVIDADE';
const PASSWORD_VALIDATION = 'VALIDACAO_SENHA';
const PASSWORD_CHANGE = 'TROCA_SENHA';
const ROUNDING_CONFIG = 'ARREDONDAMENTO';
const CLIENT_VALIDATION = 'VALIDACAO_CLIENTE';
const PARAMETER_TYPE_TEXT = 'TEXTO';
const PARAMETER_TYPE_INTEGER = 'INTEIRO';
const PARAMETER_TYPE_DECIMAL = 'DECIMAL';
const PARAMETER_TYPE_BOOLEAN = 'BOLEANO';
const PARAMETER_TYPE_NUMBER = 'NUMERIC';
const INFUSION_TIME = 'TEMPO_INFUSAO';
const PROPORTION_CAL_N = 'PROPORCAO_CALN';
const INDEXACAO_1 = 'INDEXACAO_1';
const INDEXACAO_2 = 'INDEXACAO_2';
const INDEXACAO_3 = 'INDEXACAO_3';
const INDEXACAO_4 = 'INDEXACAO_4';
const BLOCKING_INACTIVE_ACCESS = 'BLOQUEIO_ACESSO_INATIVO';
const TEMPO_CANCEL_PROSPEC = 'TEMPO_CANCEL_PROSPEC';
const PRESCRICAO_TERAPIA_EDIT = 'PRESCRICAO_TERAPIA_EDIT';
const CHAVE_CONSULTA_CFM = 'CHAVE_CONSULTA_CFM';

const ACTIVE_PARAMETERS_TYPES = [
  SCHEDULING_DAYS,
  TRANSCRIPTION_APPROVE_PARAM,
  TRANSCRIPTION_MIN_CHECKS,
  PATIENT_CLASSIFICATION_PARAM,
  CANCELLATION_REASON,
  EXPIRATION_TIME,
  INFUSION_TIME,
  PROPORTION_CAL_N,
  INDEXACAO_1,
  INDEXACAO_2,
  INDEXACAO_3,
  INDEXACAO_4,
  BLOCKING_INACTIVE_ACCESS,
  TEMPO_CANCEL_PROSPEC,
  PRESCRICAO_TERAPIA_EDIT,
  CHAVE_CONSULTA_CFM,
];

export const PARAMETERS_VALUE_TYPE_INT = 'INTEIRO';
export const PARAMETERS_VALUE_TYPE_DECIMAL = 'DECIMAL';
export const PARAMETERS_VALUE_TYPE_TEXT = 'TEXTO';
export const PARAMETERS_VALUE_TYPE_LIST_TEXT = 'LISTA_TEXTO';
export const PARAMETERS_VALUE_TYPE_BOOLEAN = 'BOOLEAN';
export const PARAMETERS_VALUE_TYPE_INTEGER = 'INTEIRO';
export const PARAMETERS_VALUE_TYPE_FILE = 'ARQUIVO';
export const PARAMETERS_VALUE_TYPE_PASSWORD = 'SENHA';

export {
  SCHEDULING_DAYS,
  TRANSCRIPTION_APPROVE_PARAM,
  TRANSCRIPTION_MIN_CHECKS,
  CANCELLATION_REASON,
  PASSWORD_VALIDATION,
  PASSWORD_CHANGE,
  ROUNDING_CONFIG,
  CLIENT_VALIDATION,
  PARAMETER_TYPE_TEXT,
  PARAMETER_TYPE_INTEGER,
  PARAMETER_TYPE_DECIMAL,
  PARAMETER_TYPE_BOOLEAN,
  PARAMETER_TYPE_NUMBER,
  PATIENT_CLASSIFICATION_PARAM,
  ACTIVE_PARAMETERS_TYPES,
  EXPIRATION_TIME,
  INFUSION_TIME,
  PROPORTION_CAL_N,
  INDEXACAO_1,
  INDEXACAO_2,
  INDEXACAO_3,
  INDEXACAO_4,
  BLOCKING_INACTIVE_ACCESS,
  TEMPO_CANCEL_PROSPEC,
  PRESCRICAO_TERAPIA_EDIT,
  CHAVE_CONSULTA_CFM,
};
